/**
 * Ensures a route param is always a string, not an array.
 * In Nuxt 4, route params can be `string | string[]`.
 */
export function ensureStringParam(param: string | string[] | undefined): string {
  if (Array.isArray(param)) {
    return param[0] ?? ''
  }
  return param ?? ''
}
